import Link from 'next/link';

import {
  Accordion,
  Heading,
  Icon,
  Loader,
  Markdown,
  usePrevious,
} from '@frontendmentorio/design-system-v2';

const COMPONENT_MAP = {
  h3: ({ node, ...props }) => <Heading level="6" tagName="h3" {...props} />,
};

const Label = ({ children, isOpen, ...props }) => (
  <span
    className="cursor-pointer flex justify-between font-secondary font-bold italic items-center px-3 py-2 uppercase text-sm"
    {...props}
  >
    {children}
    <Icon
      className="text-neutral-500"
      name={isOpen ? 'chevron-down' : 'chevron-right'}
      style="solid"
    />
  </span>
);

export default function Recommendation({
  currentUser,
  isAuthor,
  issue,
  onClick: handleClick,
}) {
  const isLoading = issue.recommendation === 'processing';
  const prevIsLoading = usePrevious(isLoading);

  if (issue.recommendation && issue.recommendation !== 'processing') {
    return (
      <Accordion
        className="bg-gray-100 w-full"
        heading={<Label>How to fix this issue</Label>}
        isOpen={prevIsLoading}
      >
        <Markdown className="p-3" componentMap={COMPONENT_MAP}>
          {issue.recommendation}
        </Markdown>
      </Accordion>
    );
  }

  if (isAuthor && currentUser?.hasActiveSubscription) {
    return (
      <button
        className="bg-cyan-600 font-secondary font-bold italic items-center px-3 py-2 rounded-lg uppercase text-sm text-white disabled:bg-neutral-500 disabled:cursor-not-allowed"
        disabled={issue.recommendation === 'processing'}
        onClick={() => handleClick(issue)}
      >
        {issue.recommendation === 'processing' ? (
          <span className="flex gap-2 items-center">
            Generating
            <Loader className="gap-1 *:bg-white *:w-1" />
          </span>
        ) : (
          <span className="flex gap-2 items-center">
            Learn how to fix this issue
            <Icon name="circle-plus" />
          </span>
        )}
      </button>
    );
  }

  if (isAuthor && !currentUser?.hasActiveSubscription) {
    return (
      <div className="bg-violet-50 border border-violet-200 flex flex-wrap gap-2 justify-between p-3 rounded w-full tablet:flex-row tablet:items-center">
        <p className="text-sm">
          <span className="font-secondary font-bold italic text-violet-600 uppercase">
            Pro:
          </span>{' '}
          Learn how to fix this issue{' '}
          <span className="hidden tablet:inline">
            with detailed explanation and code examples
          </span>
        </p>
        <Link
          className="font-secondary font-bold italic text-sm text-violet-600 uppercase underline hover:no-underline"
          href="/pro#plans"
        >
          Upgrade now
        </Link>
      </div>
    );
  }

  return null;
}
